import { toast } from "react-toastify";

const TOAST_OPTIONS = {
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const useToast = () => ({
  success: (msg) => toast.success(msg, TOAST_OPTIONS),
  error: (msg) => toast.error(msg, TOAST_OPTIONS),
  info: (msg) => toast.info(msg, TOAST_OPTIONS),
  warn: (msg) => toast.warn(msg, TOAST_OPTIONS),
});

export default useToast;
